// src/firebase.ts
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getAnalytics } from "firebase/analytics"; // 1. Імпортуємо модуль аналітики

const firebaseConfig = {
  apiKey: "AIzaSyBnWSw037_TfCRuIcACGAczyin97_wiVNU",
  authDomain: "mypaws-bca23.firebaseapp.com",
  projectId: "mypaws-bca23",
  storageBucket: "mypaws-bca23.firebasestorage.app",
  messagingSenderId: "1044627166513",
  appId: "1:1044627166513:web:55dd27fdc8f0e07b1d0c10",
  measurementId: "G-NW30VYRC2C",
};

const app = initializeApp(firebaseConfig);

// 2. Створюємо інстанси та ОБОВ'ЯЗКОВО їх експортуємо (export)
export const db = getFirestore(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const analytics = getAnalytics(app); // Ось цей експорт виправляв помилку
